import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import MultiColumnsInsight from '../../../components/MultiColumnsInsight';
import BlogDetails from '../../../components/BlogDetails';

export default function PodcastPage({
    global,
    page,
}) {
    return (
        <>
            <SeoHead
                page_name={`${page.title} | Lorien Podcast`}
                description={`An industry conversation exploring ${page.title} in Technology in the US.`}
                canonical_link={`podcasts/${page.url_slug}`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`podcast_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>{page.title}</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                editableContent={false}
            />
            <BlogDetails
                global={global}
                pathPrefix={`podcast_page.blog_details`}
                customClass={`py-5`}
                buttonLink={`/us/insights/`}
                buttonTitle={`Back to insights`}
                post={page}
            />
            <MultiColumnsInsight
                global={global}
                pathPrefix={`podcast_page.multi_columns_insight`}
                customClass={`py-5`}
                left_column_content={
                    <>
                        <h2>Want to Know More?</h2>
                    </>
                }
                left_column_button_title_1={`Get in Touch`}
                left_column_button_link_1={`/us/contact-us/`}
                left_column_button_title_2={`Search More Blogs`}
                left_column_button_link_2={`/us/insights/`}
                center_column_content={
                    <>
                        <h2>Subscribe to our newsletter</h2>
                        <p>With insight across the whole of Lorien, we'll keep you ahead of the curve on the talent market.</p>
                    </>
                }
                center_formId={`f2973c34-4388-4cf9-b22e-2a16efc93e2a`}
                right_column_content={
                    <>
                        <h2>Download our Latest Report</h2>
                        <p>Fill out the form below to gain exclusive access to the 2023 Salary Survey results!</p>
                    </>
                }
                right_formId={`f2973c34-4388-4cf9-b22e-2a16efc93e2a`}
                center_column_successPageUrl={`/us/insights/subscription-success`}
                right_column_successPageUrl={`/us/insights/subscription-success`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const page = (await Collection('podcasts')).getJsonItem(params.url_slug, 'url_slug');

    return {
        props: {
            global,
            page,
        }
    };
}

export async function getStaticPaths() {
    const pagePath = (await Collection('podcasts'))
    .filter((post) =>
        (post.country?.en?.includes("United States"))
    )
    .getPaths('url_slug');
    return {
        paths: pagePath,
        fallback: false
    }
}
